const FooterSection = () => {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-100 border-t border-gray-200">
      <div className="border-t-2 border-emerald-400" />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 sm:py-12">
        <div className="flex flex-col items-center gap-6 sm:gap-8">
          {/* Logo + tagline */}
          <div className="flex flex-col items-center gap-2">
            <img
              src="https://public.readdy.ai/ai/img_res/745bd58f-36ba-4fba-8a4b-d5c0a59cd038.png"
              alt="StockSimple"
              className="h-7 sm:h-8 w-auto"
            />
            <p className="text-gray-500 text-xs sm:text-sm text-center">Control de inventario para tiendas. Simple. Visual. Tuyo.</p>
          </div>

          {/* Nav links */}
          <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-6 text-xs sm:text-sm text-gray-500">
            {[
              { label: 'El Problema', id: 'problema' },
              { label: 'Solución', id: 'solucion' },
              { label: 'Oferta', id: 'oferta' },
              { label: 'FAQ', id: 'faq' },
              { label: 'Comprar', id: 'checkout' },
            ].map(({ label, id }) => (
              <button
                key={id}
                onClick={() => scrollTo(id)}
                className="hover:text-emerald-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                {label}
              </button>
            ))}
          </div>

          {/* SSL seal */}
          <div className="flex items-center gap-2 text-xs sm:text-sm text-gray-500">
            <i className="ri-shield-check-line text-emerald-500 text-base sm:text-lg" />
            <span>Pago Seguro SSL</span>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-6 sm:mt-8 pt-5 sm:pt-6 text-center text-xs text-gray-400 flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-0">
          <span>&copy; {new Date().getFullYear()} StockSimple. Todos los derechos reservados.</span>
          <span className="hidden sm:inline mx-2">·</span>
          <a href="#" rel="nofollow" className="hover:text-gray-600 transition-colors">Términos y Condiciones</a>
          <span className="hidden sm:inline mx-2">·</span>
          <a href="#" rel="nofollow" className="hover:text-gray-600 transition-colors">Política de Privacidad</a>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
